import { CCalendar } from './CCalendar.js';

const CCalendarPlugin = {
    install: (app) => {
        app.component(CCalendar.name, CCalendar);
    },
};

export { CCalendar, CCalendarPlugin };
//# sourceMappingURL=index.js.map
